import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiError } from 'src/api/axiosClient/types';
import { RootState } from 'src/store';
import { GetShortLinkParams, ShortLink } from '../types';
import { ShortLinkState } from './types/ShortLinkState';

const initialState: ShortLinkState = {
  loading: {
    getList: false,
    create: false,
    update: false,
    delete: false,
  },
  filter: {
    companyId: '',
    offset: 0,
    limit: 25,
    page: 0,
    sort: 'createdAt_desc', // Default sort by date created descending
  },
  list: null,
  error: null,
};

const shortLinkSlice = createSlice({
  name: 'shortLink',
  initialState,
  reducers: {
    setLoading: (
      state,
      action: PayloadAction<Partial<Record<keyof ShortLinkState['loading'], boolean>>>,
    ) => {
      state.loading = { ...state.loading, ...action.payload };
    },
    setFilter(state, action: PayloadAction<Partial<GetShortLinkParams>>) {
      state.filter = {
        ...state.filter,
        ...action.payload,
      };
    },
    setList: (
      state,
      action: PayloadAction<{
        items: ShortLink[];
        count: number;
      }>,
    ) => {
      state.list = action.payload;
    },
    setError: (state, action: PayloadAction<ApiError>) => {
      state.error = action.payload;
    },
    resetList: state => {
      state.filter = initialState.filter;
      state.list = initialState.list;
    },
    resetError: state => {
      state.error = initialState.error;
    },
    resetSlice: () => {
      return initialState;
    },
  },
});

export const { setLoading, setFilter, setList, setError, resetList, resetError, resetSlice } =
  shortLinkSlice.actions;

export const shortLinkReducer = shortLinkSlice.reducer;

export const isShortLinkLoading = (state: RootState) => state.shortLink.loading;
export const getShortLink = (state: RootState) => state.shortLink.list;
export const getShortLinkFilter = (state: RootState) => state.shortLink.filter;
export const getShortLinkError = (state: RootState) => state.shortLink.error;
